import { render, staticRenderFns } from "./CustomerCollection.vue?vue&type=template&id=41726692&scoped=true&"
import script from "./CustomerCollection.vue?vue&type=script&lang=js&"
export * from "./CustomerCollection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCollection.vue?vue&type=style&index=0&id=41726692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41726692",
  null
  
)

export default component.exports